;
(function ($) {
  var dataKey = 'app.include';
  var Include = function Include(element, options) {
    this.element = element;
    this.init(options);
  };
  Include.prototype = {
    /**
     * Initialise Includes
     * Makes and AJAX call and returns the requested partial file.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      var ajaxUrl = './shared/' + $(this.element).data('include') + '.html';
      var $container = $(this.element);
      $.ajax({
        type: 'GET',
        url: ajaxUrl,
        cache: false,
        data: {},
        success: function success(data) {
          _this._onAjaxSuccess($container, data);
        },
        error: function error(xhr, text, exception) {
          _this._onAjaxError();
        }
      });
    },
    /**
     * On AJAX Success
     * Injects the returned HTML into the required HTML element container.
     * Re-initialises all plugins for the container.
     * @private
     * @param {string} $container - The container element in which to inject the returned HTML.
     * @param {string} data - HTML returned from the AJAX request.
     */

    _onAjaxSuccess: function _onAjaxSuccess($container, data) {
      $container.html(data);
      app.initElementListeners($container);
    },
    /**
     * On AJAX Error
     * Logs out an error if the AJAX request fails.
     * @private
     */

    _onAjaxError: function _onAjaxError() {
      console.log('Error with ajax request');
    }
  };

  /**
   * Global callback function which by default all [data-include] triggers this plugin.
   * @method $.fn.app_accordion()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_include();
   */

  $.fn.app_include = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof Include) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Include(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);